import { styled } from "@mui/material/styles";
import { Box, Divider } from "@mui/material";
import { getColor } from "../color/color";

// Styled Container
export const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
}));
export const AmountTextFields = {
  width: "120px",
  height: "30px",
  textAlign: "center",
  borderRadius: 2,
  border: "1px solid black",
  padding: "10px",
  lineHeight: "30px",
};
export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: getColor.Platinum,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const StyledACRButton = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20%",
}));
